(() => {
  if (customElements.get('rp-product-introduction')) return;
  customElements.define('rp-product-introduction', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.rp-product-introduction__content');
      this.button = this.querySelector('button');
      this.abort = new AbortController();
      this.button.addEventListener('click', () => {
        const open = this.button.getAttribute('aria-expanded') !== 'true';
        this.button.setAttribute('aria-expanded', String(open));
        this.toggleAttribute('data-expanded', open);
        this.button.textContent = open ? 'View less' : 'View more';
      }, { signal: this.abort.signal });
      this.observer = new ResizeObserver(() => {
        const limit = parseFloat(getComputedStyle(this.content).lineHeight) * 2;
        this.button.hidden = this.content.scrollHeight <= limit + 2;
      });
      this.observer.observe(this.content);
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
})();
